import { connect } from 'react-redux';
import ImportPopUp from '../../components/sections/ImportPopUp.js';
import { importSettings } from '../../actions';

const mapStateToProps = state => {
  return {
    importPopupOpen: state.importPopupOpen,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    importSettings: data => {
      dispatch(importSettings(data));
    },
  };
};

const ImportPopUpRedux = connect(mapStateToProps, mapDispatchToProps)(ImportPopUp);

export default ImportPopUpRedux;
